import { GetRatingRoutes } from '@/services/rating'
import router from '@/router'
import useRouterStore, { RouteGroups } from '@/stores/useRouterStore'
import { useAuthStore } from '@/stores/auth'
import PermissionsV1 from '@/router/permissions/v1'
import { CyrillicToLatin } from '@/utils/stringHelper'

const reformatName = (str, joinAnd = '-') => {
  return str
    .split(' ')
    .map(s => s.charAt(0))
    .join('')
    .toLowerCase()
    .split(':')
    .join(joinAnd)
}

export async function InitRatingRoutes() {
  const authStore = useAuthStore()
  if (!authStore.userData) return

  try {
    const response = await GetRatingRoutes()
    const ratingTypes = response.data ?? []

    if (!ratingTypes.length) return

    ratingTypes.forEach(type => {
      router.addRoute('DefaultLayout', {
        path: `/rating/${CyrillicToLatin(reformatName(type.title))}`,
        name: `rating.${type.id}`,
        meta: {
          typeId: type.id,
          positions: type.positions,
          middleware: ['auth', 'has_access'],
          accesses: PermissionsV1['RATING.INDEX'],
          accesses_redirect: true,
        },
        component: () => import('@/views/rating/Index.vue'),
      })
    })

    const routeStore = useRouterStore()
    routeStore.addToGroup(RouteGroups.RESERVE, {
      name: 'rating',
      slug: 'rating',
      icon: 'pi pi-star',
      children: ratingTypes.map(type => ({
        name: type.short_title || type.title,
        slug: CyrillicToLatin(reformatName(type.title)),
        to: { name: `rating.${type.id}` },
      })),
    })
  } catch (e) {
    console.log(e)
  }
}
